import React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Link,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Skeleton from '@material-ui/lab/Skeleton'
import { get } from 'lodash'
import { projectHeaders } from './constants'
import { Link as RouterLink } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { formatDate } from '../../helpers/dateHelper'
import { orderBy as orderByLodash } from 'lodash'
import { isSafari } from '../../helpers/filter'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  tableHeadRoot: {
    '& .MuiTableCell-head': {
      padding: '16px !important',
      fontSize: '13px',
      '&:first-child': {
        paddingLeft: '25px !important',
      },
    },
  },
  tableBodyRoot: {
    '& .MuiTableCell-body': {
      padding: '16px !important',
      fontSize: '13px',
      '&:first-child': {
        paddingLeft: '25px !important',
      },
    },
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  activeProject: {
    fontWeight: 500,
  },
  archivedProject: {
    fontWeight: 500,
  },
}))

const CustomTableHead = React.memo((props) => {
  const {
    orderHandler = () => {},
    orderByHandler = () => {},
    orderBy = 'created_date',
    order = 'desc',
  } = props
  const classes = useStyles()

  const sortHandler = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    orderHandler(isAsc ? 'desc' : 'asc')
    orderByHandler(property)
  }
  return (
    <TableHead>
      <TableRow className={classes.tableHeadRoot}>
        {projectHeaders.map((headCell) => (
          <TableCell
            style={{ left: 0, paddingTop: 0 }}
            key={headCell.data}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.data ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.data}
              direction={orderBy === headCell.data ? order : 'asc'}
              onClick={(e) => sortHandler(e, headCell.data)}
            >
              {headCell.label}
              {orderBy === headCell.data ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
})

const CustomTableBody = React.memo((props) => {
  const loading = useSelector((state) => state.dashboardReducer.loading)
  const classes = useStyles()
  const { projects = [], orderBy = 'created_date', order = 'desc' } = props
  const getSortedList = () => {
    return orderByLodash(projects, orderBy, order)
  }

  return (
    <TableBody>
      {!loading ? (
        projects.length > 0 ? (
          getSortedList().map((row) => (
            <TableRow key={row.project_id} className={classes.tableBodyRoot}>
              {projectHeaders.map((cell) => {
                return (
                  <TableCell
                    style={{ left: 0 }}
                    key={row.project_id + '-' + cell.id}
                    className={
                      cell.id === 'project_name' &&
                      (row.archived
                        ? classes.archivedProject
                        : classes.activeProject)
                    }
                  >
                    {cell.type === 'date' ? (
                      formatDate(get(row, cell.data))
                    ) : cell.id === 'project_name' ? (
                      <Link
                        color={row.archived ? 'textSecondary' : 'initial'}
                        component={RouterLink}
                        to={'/dashboard/' + row.project_id}
                        state={{
                          totalTcin: row?.project_stats?.tcin_count || 50,
                        }}
                      >
                        {get(row, cell.data)}
                      </Link>
                    ) : (
                      get(row, cell.data)
                    )}
                  </TableCell>
                )
              })}
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={24} align="center">
              No Projects
            </TableCell>
          </TableRow>
        )
      ) : (
        [...Array(10)].map((k, i) => (
          <TableRow key={i}>
            <TableCell key={i} style={{ left: 0, paddingTop: 0 }}>
              <Skeleton />
            </TableCell>
            {projectHeaders.map((cell) => {
              return (
                <TableCell key={i + '-' + cell.id}>
                  <Skeleton />
                </TableCell>
              )
            })}
          </TableRow>
        ))
      )}
    </TableBody>
  )
})

const ProjectTable = React.memo((props) => {
  return (
    <TableContainer
      style={{
        height: isSafari() ? 'calc(100vh - 280px)' : 'calc(100vh - 260px)',
      }}
    >
      <Table stickyHeader>
        <CustomTableHead
          isMyProjects={props.isMyProjects}
          orderHandler={props.orderHandler}
          orderByHandler={props.orderByHandler}
          orderBy={props.orderBy}
          order={props.order}
        />
        <CustomTableBody
          isMyProjects={props.isMyProjects}
          orderBy={props.orderBy}
          order={props.order}
          projects={props.projects}
        />
      </Table>
    </TableContainer>
  )
})

export default ProjectTable
